export default "/images/personagem-tentativas-excedidas.png?8ac382ffd118783a8581f39943009c1f";